import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal, Form, InputNumber, Radio, Button, message, Space } from 'antd';
import { useState } from 'react';
import { post } from '../../../axios/axios';

const WithdrawModal = NiceModal.create(({ availableCommission = 0, onSuccess }) => {
    const modal = useModal();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    // 提交提现申请
    const handleSubmit = async (values) => {
        try {
            // 获取token
            const userInfo = localStorage.getItem('CommissionUserInfo');
            if (!userInfo) {
                message.error('未找到登录信息，请重新登录');
                modal.hide();
                return;
            }

            const parsed = JSON.parse(userInfo);
            const token = parsed?.['Commission-Token'];
            if (!token) {
                message.error('未找到token，请重新登录');
                modal.hide();
                return;
            }

            // 验证提现金额
            if (values.withdrawAmount > availableCommission) {
                message.error('提现金额不能超过可提现佣金');
                return;
            }

            setLoading(true);
            const res = await post(
                '/member/commission/withdraw/apply',
                {
                    withdrawAmount: values.withdrawAmount,
                    withdrawType: values.withdrawType,
                },
                {
                    headers: { 'Commission-Token': token },
                },
            );

            if (res.code === 0) {
                message.success('提现申请已提交');
                modal.hide();
                // 调用成功回调，刷新数据
                if (onSuccess) {
                    onSuccess();
                }
            }
        } catch (error) {
            console.error('提现申请失败:', error);
            // 错误信息已经在axios拦截器中通过message.error显示了
        } finally {
            setLoading(false);
        }
    };

    // 关闭弹窗
    const handleCancel = () => {
        modal.hide();
    };

    return (
        <Modal
            title="申请提现"
            open={modal.visible}
            onCancel={handleCancel}
            footer={null}
            width={400}
            destroyOnClose
        >
            <Form
                form={form}
                onFinish={handleSubmit}
                layout="vertical"
                initialValues={{
                    withdrawType: 1, // 默认选择银行卡
                }}
            >
                <div style={{ marginBottom: '16px', color: '#666' }}>
                    可提现金额：<span style={{ fontWeight: 'bold', color: '#333' }}>¥{availableCommission.toLocaleString()}</span>
                </div>

                <Form.Item
                    name="withdrawAmount"
                    label="提现金额（元）"
                    rules={[
                        { required: true, message: '请输入提现金额' },
                        {
                            type: 'number',
                            max: availableCommission,
                            message: `提现金额不能超过可提现佣金（¥${availableCommission.toLocaleString()}）`,
                        },
                    ]}
                >
                    <InputNumber
                        style={{ width: '100%' }}
                        placeholder="请输入提现金额"
                        min={1}
                        max={availableCommission}
                        precision={0}
                        formatter={(value) => (value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '')}
                        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                    />
                </Form.Item>

                <Form.Item
                    name="withdrawType"
                    label="提现方式"
                    rules={[{ required: true, message: '请选择提现方式' }]}
                >
                    <Radio.Group>
                        <Space direction="vertical">
                            <Radio value={1}>银行卡</Radio>
                            <Radio value={2}>支付宝</Radio>
                        </Space>
                    </Radio.Group>
                </Form.Item>

                <Form.Item>
                    <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                        <Button onClick={handleCancel}>取消</Button>
                        <Button type="primary" htmlType="submit" loading={loading}>
                            确认提现
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    );
});

export default WithdrawModal;
